import { Component, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';

import { TxnFilter } from '../txns/txn.service';
import { FilterService } from './filter.service';
import { ApiClient } from '../common/api-client.service';

@Component({
  templateUrl: './sidebar.component.html'
})
export class SearchSidebarComponent implements OnInit {
  limitOptions = [50, 100, 200, 500, 1000];
  sortOptions = [
    ['Sort by date (descending)', 'date_desc'],
    ['Sort by date (ascending)', 'date_asc'],
    ['Sort by fund', 'fund'],
    ['Sorty by account', 'account'],
  ];

  accounts = [];
  funds = [];
  selectedFunds = {};
  selectedAccts = {};
  startDate: Date;
  endDate: Date;
  limit = 50;
  sortBy = 'date_desc';
  private fingerprint = JSON.stringify(this.filterData());

  constructor(
    private filterService: FilterService,
    private apiClient: ApiClient,
    private datePipe: DatePipe,
  ) {}

  ngOnInit() {
    this.apiClient.get<any>('/api/v1/ledger/details').toPromise().then(ledger => {
      this.accounts = ledger.accounts;
      this.funds = ledger.funds;
    });
  }

  update(): void {
    setTimeout(() => {
      const params = this.filterData();
      this.fingerprint = JSON.stringify(params);
      this.filterService.update(params);
    }, 100); // delay is for the mat date selector
  }

  updateIfChanged(): void {
    const newFingerprint = JSON.stringify(this.filterData());
    if ( newFingerprint !== this.fingerprint ) {
      this.update();
    }
  }

  private filterData(): TxnFilter {
    const params: TxnFilter = {limit: this.limit, order: this.sortBy};

    if ( this.startDate ) {
      params.start_date = this.datePipe.transform(this.startDate, 'yyyy-MM-dd');
    }

    if ( this.endDate ) {
      params.end_date = this.datePipe.transform(this.endDate, 'yyyy-MM-dd');
    }

    const fundIds = Object.keys(this.selectedFunds).
      filter(id => this.selectedFunds[id] === true).
      map(id => parseInt(id, 10));
    if ( fundIds.length ) { params['fund_ids[]'] = fundIds }

    const acctIds = Object.keys(this.selectedAccts).
      filter(id => this.selectedAccts[id] === true).
      map(id => parseInt(id, 10));
    if ( acctIds.length ) { params['account_ids[]'] = acctIds }

    return params;
  }
}



// WEBPACK FOOTER //
// /srv/src/app/search/sidebar.component.ts